module.exports = __webpack_public_path__ + "img/ip-more-rounds.1edaac88.svg";